import { toast } from "@/components/ui/use-toast";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { getReservation } from "../actions/paymentAction";
import PDFViewer from "../components/PDFViewer";
import BookingDetails from "../components/BookingFinal/BookingDetails";
import PassengerDetails from "../components/BookingFinal/PassengerDetails";
import FlightDetails from "../components/BookingFinal/FlightDetails";
import FareDetails from "../components/BookingFinal/FareDetails";
import FareBreakdown from "../components/FareBreakdown";
import Loading from "../common/Loading";

const ViewBooking = () => {
  const params = new URLSearchParams(location.search);
  const [reservationResp, setReservationResp] = useState(null);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    if (params.get("success")) {
      dispatch(
        getReservation(params.get("bookcode"), true, (resp) => {
          setReservationResp(resp);
          setIsLoading(false);

        })
      );
    }
  }, []);

  return (
    isLoading ? <Loading label="Fetching details... Please wait!" /> :
      <div className="border border-slate-200 max-w-screen-lg mx-auto my-3">
        {/* {reservationResp && <PDFViewer src={reservationResp.Result.PDFTicket} />} */}
        {/* <BookingResponsePage booking={reservationResp} /> */}
        {reservationResp && (
          <table className="text-left w-full  border-slate-500 align-top text-sm table-booking">
            <BookingDetails booking={reservationResp} />
            {reservationResp.Result.Reservation && reservationResp.Result.Reservation.map((flight, i) => (<FlightDetails flight={flight} i={i} />))}
            <FareDetails pricingDetail={reservationResp.Result.Pricing} />
            <FareBreakdown />
            {reservationResp.Result.Passengers.length > 0 &&
              reservationResp.Result.Passengers.map((passenger, i) => (
                <PassengerDetails passenger={passenger} index={i + 1} />
              ))}
          </table>
        )}
      </div>
  );
};

export default ViewBooking;
